import Hero from "./Hero"
import SignUp from "./SignUp"

function Landing(){
  return (
    <>
      <Hero />
      <SignUp />
    </>
  )
}

export default Landing;